export const animation = {
  maskShowDuration: 1,
  maskHideDuration: 1.4,
}
